import type { SVGProps } from 'react';

export const More = (props: SVGProps<any>) => (
  <svg
    role="img"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{'more'}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <g
        fill={props.fill}
        fillRule="nonzero"
        transform="translate(1.875 8.125)"
      >
        <circle cx="1.975" cy="1.975" r="1.975" />
        <circle cx="8.125" cy="1.975" r="1.975" />
        <circle cx="14.375" cy="1.975" r="1.975" />
      </g>
    </g>
  </svg>
);
